import { z } from 'zod'

export const messageRole = z.enum(['user', 'assistant'])
export const messageType = z.enum(['text', 'image', 'audio', 'video', 'document', 'reaction'])

export const message = z.object({
    id: z.string(),
    role: messageRole,
    type: messageType,
    mediaUrl: z.string().nullable(),
    content: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
})

export type Message = z.infer<typeof message>
export type MessageRole = z.infer<typeof messageRole>
export type MessageType = z.infer<typeof messageType>
